import { Text } from '@/components/shared/Text/Text';

interface InfoRowProps {
  label: string;
  value: React.ReactNode;
}

export const InfoRow = ({ label, value }: InfoRowProps) => (
  <div className="grid grid-cols-[1fr,2fr,1fr] items-center py-2 font-medium">
    <Text.Regular weight="bold">{label}</Text.Regular>
    {value}
  </div>
);
